import React from "react";



const Node = () => {
return(
    
<>

<section class="about1" id="">

<div class="max-width" >
{/* <!-- <h2 class="title">About me</h2> --> */}
<div class="about-content">

<div class=" right">
<div class="text">Node.JS</div>
<h3>Hire the best Node JS Developers in Mumbai<br/>
<span>Our top-notch Node JS developers work hard to give you the best experience by delivering high-quality software.<br/>
Coding and Deploying made easy!<br/>
Customizable Node.JS Software<br/>
Client retention and satisfaction<br/>
Ranging across industries<br/>
On-Time Delivery<br/>

</span>
</h3>
</div>
<div class=" left">
<img src="assets/images/1.png" alt="1"/>
</div>
</div>

</div>
</section>
<div className="extra">
    <h3>Node JS services we provide:<br/>
    <span>
    Portal Development: Our team of developers at ShellCode Solutions provide user-friendly and customizable solutions for web-application portal.<br/>
Node JS API Integration: Our Node JS developers create efficient APIs with Node.JS and MongoDB and improve communication.<br/>
Node JS for Web UI/UX design: Our developers work efficiently to offer aesthetic and rich UI/UX design for your app.<br/>
Plugins Development: We offer custom Node JS Plugins to maximize the productivity and functionality of your ventures.<br/>
CMS Development: We provide seamless CMS integration and a vast room to handle web content in a productive manner.<br/>
Support and Maintenance: We provide constant Node.js support and maintenance whenever you need us.<br/>
    </span></h3>
    
    <h3>Why hire the best Node JS developers in Mumbai:<br/>
    <span>
    Our Node JS developers offer optimum experience and stay in the loop, ensuring complete transparency.<br/>
Advanced Programmers: Our advanced programmers have a sharp sense of top-notch technology and tools and make optimum use to deliver results.<br/>
Customized Solutions: We acknowledge your needs and celebrate diversity in every project, delivering the best, always!<br/>
Dedicated Force: Our team of dedicated developers makes use of state-of-the-art technology and delivers the best result.<br/>
Flexibility: Our agile methodology allows for flexibility in our process so that we can prioritize your needs.<br/>
Economical Rates: We deliver solutions that are easy on the pocket!<br/>
Privacy and Security: Security is our topmost priority. We build secure software and keep bugs away.<br/>
    <br/></span>
    </h3>

    <h3>Best Node JS Development in Mumbai across industries<br/>
    <span>We offer versatile services which are not limited to specific industries. Our developers design solutions for every industry.<br/>
    </span>
    </h3>
    <h3>Our Tools and Technologies<br/>
    <span>We provide our employees with an inventory of top-notch tools and technologies so that they continue to work wonders and deliver results.<br/>
    </span>
    </h3>
    <h3>Choose from a variety of engagement models<br/>
    <span>We differentiate between projects and craft a unique development method for each project individually. No two projects are similar. We know that!<br/>
    </span>
    </h3>

   
</div>
    </>
)
}

export default Node;
